import { Control } from 'ol/control';
import { MapSearchResponseItem } from '../../../services/open-street.api';

export class SearchResultControls extends Control {
  constructor(options: {
    target?: string | HTMLElement | undefined,
    data?: MapSearchResponseItem[],
    onClose: (e: Event) => void
    onItemClick: (v: MapSearchResponseItem | null) => void
  }) {
    const element = document.createElement('div');
    element.className = 'search-result ol-unselectable ol-control';

    const listContainer = document.createElement('div');
    listContainer.className = 'result-container';

    const listHeader = document.createElement('div');
    listHeader.className = 'list-header';
    listHeader.innerHTML = 'Wyniki wyszukiwania:';

    const closeBtn = document.createElement('button');
    closeBtn.id = 'search-result_close_button';
    closeBtn.type = 'button';
    closeBtn.innerHTML = '';

    closeBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      options.onClose(e);
    });

    listHeader.append(closeBtn);

    listContainer.append(listHeader);
    const listWrapper = document.createElement('div');
    listWrapper.className = 'list-wrapper';


    if (options.data?.length) {
      const list = document.createElement('ul');
      options.data.forEach((v: MapSearchResponseItem) => {
        const li = document.createElement('li');
        const link = document.createElement('a');
        link.href = '#';
        link.innerHTML = v.display_name;
        link.addEventListener('click', (e: Event) => {
          e?.preventDefault();
          e?.stopPropagation();
          options.onItemClick(v);
        });
        li.append(link);
        list.append(li);
      });
      listWrapper.append(list);
      listContainer.append(listWrapper);
    } else {
      const message = document.createElement('div');
      message.innerHTML = 'Brak wynników';
      message.style.textAlign = 'center';
      message.style.fontWeight = 'bold';
      listContainer.append(message);
    }

    element.append(listContainer);
    super({
      element,
      target: options?.target
    });
  }
}
